import { useEffect, useState } from 'react';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';
import AboutGrid from './AboutGrid';
import Banner from './Banner';
import ExpertContent from './ExpertContent';
import Material from './Material';
import TypeList from './TypeList';
import { fireExpandCollpaseWidgetEvent } from './common';
import { ScrollAnchorAge } from './styled';
import VideoContent from './VideoContent';
import HeadingOnly from './HeadingOnly';
import { bundleId } from '../../../Constants/ProductPage';
import { getExperimentTypeOfUser } from '../../../Utils/helper';

export default function AbouSection(props) {
  const {
    productData,
    descriptionRef,
    platform,
    showAPlusPlusExp,
    openWidgetOnClick,
    collapse,
    showNewLandingPageUI,
    showNewBannerWidgetView,
  } = props;

  let widgetDataSEO = JSON.parse(JSON.stringify(productData?.widgets));

  const [widgetData, setWidgetData] = useState(widgetDataSEO);
  const clickedBodyHandler = (categoryName, index, name) => {
    if (window.scrollY > 10)
      fireExpandCollpaseWidgetEvent(categoryName, productData, index, name);
  };
  const dataObj = {
    category: 'impression_section_in_pdp',
    section_name: 'About Section',
    section_id: '',
    deeplink_value: null,
    shape: '',
    card_ids: [],
    sku_id: productData?.id,
  };
  const WidgetContainImage = widgetData?.[0]?.type?.key == 'media';
  const productCategory = productData?.product_category;
  useEffect(() => {
    setWidgetData([...productData?.widgets]);
  }, [productData?.id]);
  const collapseAll =
    (getExperimentTypeOfUser() == 'C' && showAPlusPlusExp) || collapse;
  return (
    <ScrollWrapper data={dataObj} sectionId={'aboutSection'} fromPdp={true}>
      <div ref={descriptionRef}>
        <ScrollAnchorAge id="Age" rel="nofollow"></ScrollAnchorAge>

        {widgetData?.map((element, index) => {
          const defaultOpen =
            !collapseAll && (productData?.id === bundleId || index === 0);

          switch (element?.type?.key) {
            case 'article':
              return (
                <Material
                  key={`aboutsection${index}`}
                  clickedHandler={clickedBodyHandler}
                  productCategory={productCategory}
                  itemData={element}
                  index={index}
                  Ido={defaultOpen}
                  WidgetContainImage={WidgetContainImage}
                  showNewLandingPageUI={showNewLandingPageUI}
                />
              );

            case 'nestedgrid':
              break;
            case 'grid':
              return (
                <AboutGrid
                  key={`aboutsection${index}`}
                  itemData={element}
                  clickedHandler={clickedBodyHandler}
                  productCategory={productCategory}
                  index={index}
                  Ido={defaultOpen}
                  WidgetContainImage={WidgetContainImage}
                  openWidgetOnClick={openWidgetOnClick}
                  showNewLandingPageUI={showNewLandingPageUI}
                />
              );
            case 'list':
              return (
                <TypeList
                  key={`aboutsection${index}`}
                  itemData={element}
                  clickedHandler={clickedBodyHandler}
                  productCategory={productCategory}
                  index={index}
                  Ido={defaultOpen}
                  WidgetContainImage={WidgetContainImage}
                  showNewLandingPageUI={showNewLandingPageUI}
                />
              );
            case 'media':
              if (element?.type?.value == 'Banner') {
                return (
                  <Banner
                    clickedHandler={clickedBodyHandler}
                    key={`aboutsection${index}`}
                    bannerUrl={element?.widgetContent[0].url}
                    title={element?.title}
                    index={index}
                    productCategory={productCategory}
                    itemData={element}
                    Ido={defaultOpen}
                    bannerAlt={
                      element?.widgetContent[0].imageAltName
                        ? element?.widgetContent[0].imageAltName
                        : `${element?.widgetContent[0].fallbackAltName} about banner`
                    }
                    WidgetContainImage={WidgetContainImage}
                    showNewLandingPageUI={showNewLandingPageUI}
                    showNewBannerWidgetView={true}
                  />
                );
              }
              break;
            case 'expertGrid':
              return (
                <ExpertContent
                  key={`aboutsection${index}`}
                  itemData={element}
                  productCategory={productCategory}
                  clickedHandler={() => clickedBodyHandler(element)}
                  index={index}
                  Ido={defaultOpen}
                  WidgetContainImage={WidgetContainImage}
                  showNewLandingPageUI={showNewLandingPageUI}
                />
              );
            case 'video':
              return (
                <VideoContent
                  itemData={element}
                  productCategory={productCategory}
                />
              );
            case 'heading':
              return (
                <HeadingOnly
                  itemData={element}
                  productCategory={productCategory}
                />
              );
          }
        })}
      </div>
    </ScrollWrapper>
  );
}
